// @flow

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import classNames from 'classnames';

// -- views
import NumberInputModal from './NumberInputModal';
import NumberButtonView from './NumberButtonView';

export default class NumberSelector extends Component {

  static propTypes = {
    onChange: PropTypes.func.isRequired,

    nbButtons: PropTypes.number,

    value: PropTypes.number,

    min: PropTypes.number,

    max: PropTypes.number
  };

  static defaultProps = {
    nbButtons: 7,

    max: 1000,

    value: null
  };

  state = {
    displayInputModal: false
  };

  onNumberChange = (value) => {
    if (value > this.props.max) {
      this.props.onChange(this.props.max);
    } else {
      this.props.onChange(value);
    }
  }

  onSelectClicked = () => {
    this.setState({
      displayInputModal: true
    })
  };

  onHideInputModal = () => {
    this.setState({
      displayInputModal: false
    });
  }

  // -- renderers

  renderNumberButtons() {
    const buttonsView = [];

    const max = this.props.nbButtons > this.props.max ? this.props.max : this.props.nbButtons;
    for (let i = 1; i <= max; i++) {
      buttonsView.push(
        <NumberButtonView
          key={i}
          value={i}
          onSelect={this.onNumberChange}
          isSelected={this.props.value === i}
        />
      );
    }

    return (buttonsView);
  }

  renderInputModal() {
    if (this.state.displayInputModal !== true) {
      return (<span></span>);
    }

    return (
      <NumberInputModal
        show={true}
        onHide={this.onHideInputModal}
        title={'Nombre de couverts'}
        onChange={this.onNumberChange}
        max={this.props.max}
        min={this.props.min}
      />
    );
  }

  renderNumberPicker() {
    const options = [];

    if (this.props.nbButtons > this.props.max) {
      return (null);
    }

    for (let i = this.props.nbButtons + 1; i <= this.props.max; i++) {
      options.push({
        label: i,
        value: i
      });
    }

    const isPlusMode = this.props.value <= this.props.nbButtons;

    const className = classNames('modal_btn', {
      active: !isPlusMode
    });

    return (
      <div className="number_selector__select number_button_view">
        <div
          className={className}
          onClick={this.onSelectClicked}
        >
          {isPlusMode &&
            <span>+</span>
          }
          {!isPlusMode &&
            <span>{this.props.value}</span>
          }
        </div>
      </div>
    );
  }

  render() {
    return (
      <div className="number_selector">
        {this.renderNumberButtons()}
        {this.renderNumberPicker()}
        {this.renderInputModal()}
      </div>
    )
  }

}
